export type FilterType =
   | 'source'
   | 'stages'
   | 'tags'
   | 'created'
   | 'age'
   | 'pond_lead'
   | 'Ponds'
   | 'inquired_property'

export const getFilterIcon = (type: FilterType) => {
   switch (type) {
      case 'source':
         return (
            <svg
               xmlns="http://www.w3.org/2000/svg"
               width="18"
               height="18"
               viewBox="0 0 18 18"
               fill="none"
               className="mr-2"
            >
               <path
                  d="M0 13.5V3.75C0 2.0955 1.3455 0.75 3 0.75H4.5C4.848 0.75 5.196 0.83175 5.5065 0.987L7.87275 2.1705C7.97625 2.22225 8.0925 2.24925 8.208 2.24925H12C14.0677 2.24925 15.75 3.9315 15.75 5.99925H7.518C5.5395 5.99925 3.76575 7.32375 3.2025 9.2265L1.19775 16.2308C0.465 15.546 0 14.5793 0 13.5ZM17.6198 8.26275C17.2605 7.7805 16.713 7.50375 16.1138 7.494C16.1025 7.494 16.0935 7.5 16.0823 7.5H7.518C6.1995 7.5 5.01675 8.38275 4.6425 9.6465L2.529 17.0287C2.91375 17.1623 3.32025 17.25 3.75 17.25H13.1685C14.838 17.25 16.281 16.176 16.77 14.5448L17.919 9.95775C18.0945 9.37125 17.985 8.754 17.6198 8.26275Z"
                  fill="white"
               />
            </svg>
         )
      case 'stages':
         return (
            <svg
               xmlns="http://www.w3.org/2000/svg"
               width="18"
               height="16"
               viewBox="0 0 18 16"
               fill="none"
               className="mr-2"
            >
               <rect width="18" height="4" rx="2" fill="#D9D9D9" />
               <rect y="6" width="18" height="4" rx="2" fill="#D9D9D9" />
               <rect y="12" width="18" height="4" rx="2" fill="#D9D9D9" />
            </svg>
         )
      case 'tags':
         return (
            <svg
               xmlns="http://www.w3.org/2000/svg"
               width="18"
               height="18"
               viewBox="0 0 18 18"
               fill="none"
               className="mr-2"
            >
               <g opacity="0.7" clipPath="url(#clip0_7028_2954)">
                  <path
                     d="M16.1447 6.21284L10.4529 0.659092C9.95866 0.164092 9.24766 -0.0781579 8.55691 0.0208421L3.39091 0.727342C2.98066 0.783592 2.69341 1.16159 2.74966 1.57184C2.80591 1.98209 3.18316 2.26859 3.59491 2.21309L8.76166 1.50659C8.99116 1.47509 9.22816 1.55384 9.39991 1.72559L15.0924 7.27934C15.8762 8.06309 15.9527 9.28934 15.3347 10.1646C15.1592 9.81434 14.9424 9.48059 14.6514 9.18959L9.04516 3.63059C8.55166 3.13709 7.84741 2.89934 7.14916 2.99234L1.98241 3.69884C1.64191 3.74534 1.37641 4.01759 1.33891 4.35959L0.765157 9.54659C0.690157 10.2298 0.925657 10.8996 1.41316 11.3863L6.97516 16.9011C7.68316 17.6098 8.62441 17.9991 9.62566 17.9991H9.63841C10.6449 17.9961 11.5884 17.6001 12.2957 16.8838L14.6709 14.4778C15.3662 13.7736 15.7157 12.8586 15.7382 11.9368L16.1709 11.5048C17.6147 10.0423 17.6064 7.67084 16.1469 6.21209L16.1447 6.21284ZM4.50016 7.49984C4.08616 7.49984 3.75016 7.16384 3.75016 6.74984C3.75466 5.76884 5.24566 5.76959 5.25016 6.74984C5.25016 7.16384 4.91416 7.49984 4.50016 7.49984Z"
                     fill="white"
                  />
               </g>
               <defs>
                  <clipPath id="clip0_7028_2954">
                     <rect width="18" height="18" fill="white" />
                  </clipPath>
               </defs>
            </svg>
         )
      case 'created':
         return (
            <svg
               xmlns="http://www.w3.org/2000/svg"
               width="18"
               height="18"
               viewBox="0 0 18 18"
               fill="none"
               className="mr-2"
            >
               <g opacity="0.7" clipPath="url(#clip0_7028_2951)">
                  <path
                     d="M0 14.25C0.00119089 15.2442 0.396661 16.1973 1.09966 16.9003C1.80267 17.6033 2.7558 17.9988 3.75 18H14.25C15.2442 17.9988 16.1973 17.6033 16.9003 16.9003C17.6033 16.1973 17.9988 15.2442 18 14.25V7.5H0V14.25ZM12.75 10.875C12.9725 10.875 13.19 10.941 13.375 11.0646C13.56 11.1882 13.7042 11.3639 13.7894 11.5695C13.8745 11.775 13.8968 12.0012 13.8534 12.2195C13.81 12.4377 13.7028 12.6382 13.5455 12.7955C13.3882 12.9528 13.1877 13.06 12.9695 13.1034C12.7512 13.1468 12.525 13.1245 12.3195 13.0394C12.1139 12.9542 11.9382 12.81 11.8146 12.625C11.691 12.44 11.625 12.2225 11.625 12C11.625 11.7016 11.7435 11.4155 11.9545 11.2045C12.1655 10.9935 12.4516 10.875 12.75 10.875ZM9 10.875C9.2225 10.875 9.44001 10.941 9.62502 11.0646C9.81002 11.1882 9.95422 11.3639 10.0394 11.5695C10.1245 11.775 10.1468 12.0012 10.1034 12.2195C10.06 12.4377 9.95283 12.6382 9.7955 12.7955C9.63816 12.9528 9.43771 13.06 9.21948 13.1034C9.00125 13.1468 8.77505 13.1245 8.56948 13.0394C8.36391 12.9542 8.18821 12.81 8.0646 12.625C7.94098 12.44 7.875 12.2225 7.875 12C7.875 11.7016 7.99353 11.4155 8.2045 11.2045C8.41548 10.9935 8.70163 10.875 9 10.875ZM5.25 10.875C5.4725 10.875 5.69001 10.941 5.87502 11.0646C6.06002 11.1882 6.20422 11.3639 6.28936 11.5695C6.37451 11.775 6.39679 12.0012 6.35338 12.2195C6.30998 12.4377 6.20283 12.6382 6.0455 12.7955C5.88816 12.9528 5.68771 13.06 5.46948 13.1034C5.25125 13.1468 5.02505 13.1245 4.81948 13.0394C4.61391 12.9542 4.43821 12.81 4.3146 12.625C4.19098 12.44 4.125 12.2225 4.125 12C4.125 11.7016 4.24353 11.4155 4.4545 11.2045C4.66548 10.9935 4.95163 10.875 5.25 10.875Z"
                     fill="white"
                  />
                  <path
                     d="M14.25 1.5H13.5V0.75C13.5 0.551088 13.421 0.360322 13.2803 0.21967C13.1397 0.0790176 12.9489 0 12.75 0C12.5511 0 12.3603 0.0790176 12.2197 0.21967C12.079 0.360322 12 0.551088 12 0.75V1.5H6V0.75C6 0.551088 5.92098 0.360322 5.78033 0.21967C5.63968 0.0790176 5.44891 0 5.25 0C5.05109 0 4.86032 0.0790176 4.71967 0.21967C4.57902 0.360322 4.5 0.551088 4.5 0.75V1.5H3.75C2.7558 1.50119 1.80267 1.89666 1.09966 2.59966C0.396661 3.30267 0.00119089 4.2558 0 5.25L0 6H18V5.25C17.9988 4.2558 17.6033 3.30267 16.9003 2.59966C16.1973 1.89666 15.2442 1.50119 14.25 1.5Z"
                     fill="white"
                  />
               </g>
               <defs>
                  <clipPath id="clip0_7028_2951">
                     <rect width="18" height="18" fill="white" />
                  </clipPath>
               </defs>
            </svg>
         )
      case 'age':
         return (
            <svg
               xmlns="http://www.w3.org/2000/svg"
               width="18"
               height="18"
               viewBox="0 0 18 18"
               fill="none"
               className="mr-2"
            >
               <g opacity="0.7" clipPath="url(#clip0_7028_2951)">
                  <path
                     d="M0 14.25C0.00119089 15.2442 0.396661 16.1973 1.09966 16.9003C1.80267 17.6033 2.7558 17.9988 3.75 18H14.25C15.2442 17.9988 16.1973 17.6033 16.9003 16.9003C17.6033 16.1973 17.9988 15.2442 18 14.25V7.5H0V14.25ZM12.75 10.875C12.9725 10.875 13.19 10.941 13.375 11.0646C13.56 11.1882 13.7042 11.3639 13.7894 11.5695C13.8745 11.775 13.8968 12.0012 13.8534 12.2195C13.81 12.4377 13.7028 12.6382 13.5455 12.7955C13.3882 12.9528 13.1877 13.06 12.9695 13.1034C12.7512 13.1468 12.525 13.1245 12.3195 13.0394C12.1139 12.9542 11.9382 12.81 11.8146 12.625C11.691 12.44 11.625 12.2225 11.625 12C11.625 11.7016 11.7435 11.4155 11.9545 11.2045C12.1655 10.9935 12.4516 10.875 12.75 10.875ZM9 10.875C9.2225 10.875 9.44001 10.941 9.62502 11.0646C9.81002 11.1882 9.95422 11.3639 10.0394 11.5695C10.1245 11.775 10.1468 12.0012 10.1034 12.2195C10.06 12.4377 9.95283 12.6382 9.7955 12.7955C9.63816 12.9528 9.43771 13.06 9.21948 13.1034C9.00125 13.1468 8.77505 13.1245 8.56948 13.0394C8.36391 12.9542 8.18821 12.81 8.0646 12.625C7.94098 12.44 7.875 12.2225 7.875 12C7.875 11.7016 7.99353 11.4155 8.2045 11.2045C8.41548 10.9935 8.70163 10.875 9 10.875ZM5.25 10.875C5.4725 10.875 5.69001 10.941 5.87502 11.0646C6.06002 11.1882 6.20422 11.3639 6.28936 11.5695C6.37451 11.775 6.39679 12.0012 6.35338 12.2195C6.30998 12.4377 6.20283 12.6382 6.0455 12.7955C5.88816 12.9528 5.68771 13.06 5.46948 13.1034C5.25125 13.1468 5.02505 13.1245 4.81948 13.0394C4.61391 12.9542 4.43821 12.81 4.3146 12.625C4.19098 12.44 4.125 12.2225 4.125 12C4.125 11.7016 4.24353 11.4155 4.4545 11.2045C4.66548 10.9935 4.95163 10.875 5.25 10.875Z"
                     fill="white"
                  />
                  <path
                     d="M14.25 1.5H13.5V0.75C13.5 0.551088 13.421 0.360322 13.2803 0.21967C13.1397 0.0790176 12.9489 0 12.75 0C12.5511 0 12.3603 0.0790176 12.2197 0.21967C12.079 0.360322 12 0.551088 12 0.75V1.5H6V0.75C6 0.551088 5.92098 0.360322 5.78033 0.21967C5.63968 0.0790176 5.44891 0 5.25 0C5.05109 0 4.86032 0.0790176 4.71967 0.21967C4.57902 0.360322 4.5 0.551088 4.5 0.75V1.5H3.75C2.7558 1.50119 1.80267 1.89666 1.09966 2.59966C0.396661 3.30267 0.00119089 4.2558 0 5.25L0 6H18V5.25C17.9988 4.2558 17.6033 3.30267 16.9003 2.59966C16.1973 1.89666 15.2442 1.50119 14.25 1.5Z"
                     fill="white"
                  />
               </g>
               <defs>
                  <clipPath id="clip0_7028_2951">
                     <rect width="18" height="18" fill="white" />
                  </clipPath>
               </defs>
            </svg>
         )

      case 'Ponds':
         return (
            <svg
               xmlns="http://www.w3.org/2000/svg"
               width="18"
               height="18"
               viewBox="0 0 18 18"
               fill="none"
               className="mr-2"
            >
               <g opacity="0.7" clipPath="url(#clip0_7028_2951)">
                  <path
                     d="M9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0ZM12.75 12.75H5.25V11.25H12.75V12.75ZM12.75 9H5.25V7.5H12.75V9ZM12.75 5.25H5.25V3.75H12.75V5.25Z"
                     fill="white"
                  />
               </g>
               <defs>
                  <clipPath id="clip0_7028_2951">
                     <rect width="18" height="18" fill="white" />
                  </clipPath>
               </defs>
            </svg>
         )

      case 'inquired_property':
         return (
            <svg
               xmlns="http://www.w3.org/2000/svg"
               width="18"
               height="18"
               viewBox="0 0 18 18"
               fill="none"
               className="mr-2"
            >
               <path
                  d="M15.75 16.5H13.5V10.5C13.5 10.086 13.164 9.75 12.75 9.75H9.75C9.336 9.75 9 10.086 9 10.5V16.5H2.25V2.25C2.25 1.836 2.586 1.5 3 1.5H15C15.414 1.5 15.75 1.836 15.75 2.25V16.5ZM4.5 4.5V6H6V4.5H4.5ZM8.25 4.5V6H9.75V4.5H8.25ZM12 4.5V6H13.5V4.5H12ZM4.5 8.25V9.75H6V8.25H4.5ZM8.25 8.25V9.75H9.75V8.25H8.25ZM12 8.25V9.75H13.5V8.25H12ZM4.5 12V13.5H6V12H4.5Z"
                  fill="white"
                  opacity="0.75"
               />
            </svg>
         )

      default:
         return null
   }
}
